<template>

<div>
    <form  @submit.prevent="search">        
        <div class="search-input-complex ">
            <div class="autocomplete">
                <div class="input-box">
                    <input type="text" class="form-control" ref="searchInput" placeholder="Especialidad, médico o dolencia" 
                        v-model="searchInput.name" 
                        @focus="suggestOpen='search'; error=false"
                        >
                    <div class="loading" v-if="searching">
                        <i class="icon_loading animate-spin"></i>
                    </div>
                </div>
                <div class="results-box" v-if="suggestOpen=='search' && ( medics.length>0 || especialities.length>0 )">
                    <div class="group" v-if="especialities.length>0">
                        <div class="group-name">
                            ESPECIALIDADES
                        </div>
                        <div class="group-results">
                            <div class="simple-result" v-for="especiality in especialities" :key="especiality.id" @click="selectOption(especiality,'especiality')" >
                                {{especiality.name}}
                            </div>
                        </div>
                    </div>
                    <div class="group" v-if="medics.length>0">
                        <div class="group-name">
                            DOCTORES
                        </div>
                        <div class="group-results">
                            <div class="profile-result" v-for="medic in medics" :key="medic.id" @click="selectOption(medic,'doctor')" >
                                <div class="profile-picture"> 
                                    <div class="image" v-if="medic.picture" :style="'background-image:url('+API_URL+medic.picture.urlThumb+')'"></div>
                                    
                                    <div class="avatar" v-if="!medic.picture && medic.gender=='female'" :style="'background-image:url('+require('@/assets/img/no-avatar-image-female.jpg')+')'"></div>
                                    <div class="avatar" v-if="!medic.picture && medic.gender=='male'" :style="'background-image:url('+require('@/assets/img/no-avatar-image-male.jpg')+')'"></div>

                                </div>
                                <div class="profile-data">
                                    <div class="title">{{medic.fullname}}</div>
                                    <div class="subtitle">
                                        <span v-for="especiality in medic.medicEspecialities" :key="especiality.id">{{especiality.especiality.name}} </span>
                                        <span v-if="medic.medicBusinessAddresses[0]" >{{medic.medicBusinessAddresses[0].locality.name}}, {{medic.medicBusinessAddresses[0].locality.region.name}} </span>
                                    </div>
                                </div>
                            </div>
                            <div class="simple-result" v-if="searchInput.length>0" @click="selectOption(searchInput,'especiality')">
                                <hr>
                                Buscar todos los doctores llamados <span class="highlight">"{{searchInput}}"</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="autocomplete" v-if="showLocationInput">
                <div class="input-box">
                    <input type="text" class="form-control" ref="searchRegionsInput" placeholder="En..." 
                        v-model="searchRegionsInput.name" 
                        @focus="suggestOpen='location'"
                        @keydown="startSuggest"
                        >
                    <div class="loading" v-if="searching">
                        <i class="icon_loading animate-spin"></i>
                    </div>
                </div>
                <div class="results-box" v-if="suggestOpen=='location' && regions.data.length>0">
                    <div class="group">
                        <div class="group-results">
                            <div class="simple-result" v-for="region in regions.data" :key="region.id" @click="selectOption(region,'location')">
                                {{region.name}}
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
            
            <input type="submit" class="btn_search" value="Buscar">

            <div class="animated text-left fadeInUp faster error" v-if="error">
                La búsqueda no es correcta.<br>
                Te sugerimos ingresar las primeras letras de la especialidad o nombre del médico, para recibir la sugerencia
            </div>
        </div>
        <b-form-group >
            <b-form-radio-group id="channel" v-model="searchChannel" name="channel" @change="changeChannel()">
                <b-form-radio value="presential" >Consultorio</b-form-radio>
                <b-form-radio value="video" >Videoconsulta</b-form-radio>
                <b-form-radio value="mix" >Ambos</b-form-radio>
            </b-form-radio-group>
        </b-form-group>
    </form>
</div>


</template>

<script>
import gql from 'graphql-tag'

export default {
	name: "SearchBar",
    props:{
        especiality:{
            type: Object,
            default(){
                return{
                    name:'',
                    slug:'',
                }
            }
        },
        region:{
            type: Object,
            default(){
                return{
                    name:'',
                    slug:'',
                }
            }
        }
    },
    watch: {
        especiality: function (newVal) {
            this.searchInput = newVal;
        },
        region: function (newVal) {
            this.searchRegionsInput = newVal;
        }
    },
	data(){
		return{
            showLocationInput: false,
            searchInput: this.especiality,
            searchRegionsInput: this.region,
            searchChannel: this.$route.query.channel || 'mix',
            especialities:[],
            medics: [],
            regions: {
                data:[]
            },
            suggestOpen:false,
            API_URL: process.env.VUE_APP_API_URL,
            error: false,
            searching: false
            
		}
    },
    beforeMount(){
    },
	methods:{
        startSuggest(){
            console.log('startSuggest')
            this.$apollo.queries.medics.skip = false;
            this.$apollo.queries.medics.refetch()
            this.searchInput.slug = '';
        },
        selectOption(selected,type){
            console.log('selectOption');
            if(type=='especiality'){
                this.searchInput = selected;
                this.suggestOpen='location';
                if(!this.showLocationInput){
                    this.startSearch();
                }
            }
            if(this.showLocationInput && type=='location'){
                this.searchRegionsInput = selected;
                this.suggestOpen='false';
                this.startSearch();
            }
            if(type=='doctor'){
                let destinationUrl = `/doctor/${selected.id}-${selected.slug}`;
                this.$router.push(destinationUrl);
            }
        },
        search() {
            this.searching = true
            this.error = false
            this.$apollo.query({
                query: gql`query search( $count: Int!, $search: String, $channel: String ){
                    especialities(count: $count, search: $search) {
                        data {
                            id
                            name
                            slug
                        }
                    }
                    medics(count: $count, search: $search, channel: $channel) {
                        data {
                            id
                            fullname
                            prefix
                            gender
                            slug
                            status
                            picture{
                                urlThumb
                            }
                            medicEspecialities{
                                especiality{
                                    name
                                }
                            }
                            medicBusinessAddresses{
                                locality{
                                    name
                                    region{
                                        name
                                    }
                                }
                            }
                        }
                    }
                }`,
                variables: {
                    count: 10,
					search: this.searchInput.name,
					channel: this.searchChannel,
                }
            })
            .then((data) => {                
                this.especialities = data.data.especialities.data;
                this.medics = data.data.medics.data;
                this.searching = false

                if( this.medics.length>0 || this.especialities.length>0 ){
                    this.error = false
                    this.suggestOpen = 'search'
                } else {
                    this.error = true
                    this.suggestOpen = false
                }

            })
            .catch(error => {
                console.log('error al buscar.',error);
            });
        },
        startSearch(){
            if( !this.searching ) {
                if(  this.searchInput && this.searchInput.slug != ''){
                    let destinationUrl = '/doctors/' + this.searchInput.slug;
                    if( this.showLocationInput && this.searchRegionsInput.name !=' '   ){
                        destinationUrl += '/' + this.searchRegionsInput.slug;
                    }
                    if(this.searchChannel == 'presential' || this.searchChannel == 'video'){
                        destinationUrl += '?channel=' + this.searchChannel;
                    }
                    this.$router.push(destinationUrl);
                } else {
                    this.error = true
                    this.suggestOpen = false
                }
            }else{
                this.error = true
                this.suggestOpen = false
            }
        },
        changeChannel(){
            if(  this.searchInput && this.searchInput.slug != ''){
                this.$nextTick(()=>{
                    let destinationUrl = '/doctors/' + this.searchInput.slug;
                    if( this.showLocationInput && this.searchRegionsInput.name !=' '   ){
                        destinationUrl += '/' + this.searchRegionsInput.slug;
                    }
                    if(this.searchChannel == 'presential' || this.searchChannel == 'video'){
                        destinationUrl += '?channel=' + this.searchChannel;
                    }
                    this.$router.push(destinationUrl);
                })
            }
        }
    },
    
};
</script>

<style scoped>
.search-input-complex{
	top: 0;
    padding: 0;
    max-width: 650px;
    margin: auto;
	position: relative;
	display: flex;
}

.search-input-complex .autocomplete{
	position: relative;
	text-align: left;
	text-shadow:none;
	color:#333;
    width: 100%;
}
.search-input-complex .autocomplete:first-child{
    flex-grow: 2;
    border-right: 1px solid #e4e4e4;
}
.autocomplete .input-box{
	flex-grow: 1;
}
.autocomplete .input-box .loading{
    position: absolute;
    right: 0px;
    top: 0px;
    bottom: 0px;
    display: flex;
    align-items: center;
    padding: 8px;
}

.autocomplete .input-box .loading i{
    font-size: 16px;
    color: #999;
}
.autocomplete .results-box{
    width: 100%;
    min-width: 400px;
	position: absolute;
	top: 58px;
	background-color: #fff;
	z-index: 10;
	box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.35);
}
.search-input-complex .autocomplete:first-child .form-control{
    border-radius: 3px 0px 0px 3px;
}
.autocomplete .results-box:before{
	content:'';
	width: 0;
	height: 0;
	border-style: solid;
	border-width: 0 10px 10px 10px;
	border-color: transparent transparent #fafafa transparent;
	position: absolute;
	top: -6px;
    left: 17px;
}

.autocomplete .results-box .group{
	display: flex;
	border-bottom: solid 1px #ccc;
	overflow: hidden;
}	
.autocomplete .results-box .group:first-child{
	border-radius: 3px 3px 0px 0px;
}
.autocomplete .results-box .group:last-child{
	border-radius: 0px 0px 3px 3px;
	border-bottom: none;
}

.autocomplete .results-box .group .group-name{
	font-size: 12px;
	background-color: #fafafa;
	color: #000;
	font-weight: 600;
	padding: 8px;
	width:110px;
	flex-grow:0;
	flex-shrink: 0;
	
}

.search-input-complex .error{
    background-color: #ffec70;
    padding: 8px;
    border-radius: 2px;
    position: absolute;
    top: 52px;
    font-size: .8rem;
}

.group-results{
	flex-grow: 1;
}
.group-results .simple-result{
	font-size: 14px;
    padding: 8px 12px;
    width: 100%;
    cursor: pointer;
}
.group-results .simple-result:hover{
	background-color: #f5f5f5;
}
.group-results .profile-result{
	font-size: 14px;
    padding: 8px 12px;
	width: 100%;
	display: flex;
	cursor: pointer;
}
.group-results .profile-result:hover{
	background-color: #f5f5f5;
}
.group-results .profile-result .profile-picture{
	width: 34px;
    height: 34px;
    margin-right: 10px;
	flex-grow:0;
	flex-shrink: 0; 
	border-radius: 50%;
	border: solid 1px #ccc;
    overflow: hidden;
}
.group-results .profile-result .profile-picture .image{
	width: 34px;
    height: 34px;
    background-size: cover;
    background-position: center center;
}
.group-results .profile-result .profile-data{
	flex-grow:0;
	font-size: 14px;
    padding: 3px 6px;
    width: 100%;
}
.group-results .profile-result .profile-data .title{

}
.group-results .profile-result .profile-data .subtitle{
	color: #999;
}
hr{
    margin: none;
}


.form-control {
    width: 100%;
    height: 50px;
    padding-left: 20px;
    border: 0;
    
    /* -webkit-box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.35);
    -moz-box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.35);
    box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.35); */
    font-weight: 500;
    font-size: 16px;
    font-size: 1rem;
    color: #333;
    border-radius: 0px;
}

.form-control:focus {
    outline: none;
}

@media (max-width: 575px) {
    .form-control {
        /* For less than 575px */
        padding-left: 15px;
    }
}

#custom-search-input ul {
    text-align: center;
    margin-top: 25px;
}

#custom-search-input ul li {
    display: inline-block;
    margin-right: 5px;
    font-size: 13px;
    font-size: 0.8125rem;
    font-weight: 600;
}

#custom-search-input ul li input[type="radio"] {
    display: none;
}

#custom-search-input ul li input[type="radio"]:checked+label,
#custom-search-input ul li input[type="radio"]:checked+label:hover {
    background-color: #12bcec;
    color: #fff;
}

#custom-search-input ul li input[type="radio"]:hover+label {
    background-color: #e74e84;
    color: #fff;
}

#custom-search-input ul li label {
    display: inline-block;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    background-color: black;
    background-color: rgba(0, 0, 0, 0.3);
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    -ms-border-radius: 3px;
    border-radius: 3px;
    padding: 8px 10px 6px 10px;
    line-height: 1;
    text-shadow: none;
    min-width: 80px;
    text-align: center;
    cursor: pointer;
}

#custom-search-input ul li:last-child {
    margin-right: 0;
}

.btn_search[type='submit'] {
    
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    right: 0;
    color: #fff;
    font-weight: 600;
    font-size: 16px;
    font-size: 1rem;
    top: 0;
    border: 0;
    padding: 0 25px;
    height: 50px;
    cursor: pointer;
    outline: none;
    -webkit-border-radius: 0 3px 3px 0;
    -moz-border-radius: 0 3px 3px 0;
    -ms-border-radius: 0 3px 3px 0;
    border-radius: 0 3px 3px 0;
    background-color: #12bcec;
}

.btn_search[type='submit']:hover {
    background-color: #14657b;
}

@media (max-width: 575px) {
    .btn_search[type='submit'] {
        /* For less than 575px */
        text-indent: -999px;
        background: #12bcec url(../assets/img/search.svg) no-repeat center center;
    }
}
</style>
